import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { WorkPlanningPopup } from './WorkPlanningTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import { decryptAES } from '../../../utils/Encryption';
import moment from 'moment';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class WorkPlanning extends Component {

    constructor(props) {
        super(props)
        this.masterEntryServices = new MasterEntryServices();
        this.accountTransactionServices = new AccountTransactionServices();
        this.transactionStockServices = new TransactionStockServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            globalUserID: '',
            usp_Users: [],
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            itemRowData: [],
            itemColDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            workObject: {
                idMaterialPlanning: 0,
                idWorkPlanning: 0,
                updateStatus: 0,
                planningNo: '',
                planningDate: new Date().toISOString(),
                idCustomer: 0,
                idEmployee: 0,
                EmployeeList: [],
                idPriority: 2,
                priorityList: [
                    {
                        value: 1,
                        label: "LOW"
                    },
                    {
                        value: 2,
                        label: "MEDIUM"
                    },
                    {
                        value: 3,
                        label: "HIGH"
                    },
                ],
                idWorkOrder: 0,
                workOrderList: [],
                deleteItemsList: [],
            },
            itemObject: {
                idWorkPlanningItems: 0,
                idMaterialPlanning: 0,
                drawingNo: '',
                idType: 1,
                itemType: "",
                idItem: 0,
                ItemList: [],
                quantity: 0,
                idPlanning: 0,
                planningList: [],
                remarks: '',
                TypeList: [
                    {
                        value: 1,
                        label: "RAW MATERIAL"
                    },
                    {
                        value: 2,
                        label: "FINISHED GOODS"
                    },
                    {
                        value: 3,
                        label: "SEMI FINISHED"
                    },
                    {
                        value: 4,
                        label: "SCRAP MATERIAL"
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForPurchase: {
                idWorkOrder: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "work order"
                        ),
                    },
                ],
            },
            validationRulesForItem: {
                idItem: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item"
                        ),
                    },
                ],
            },
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetDetailsFields();
        this.resetItemDetails();
        this.setState({ isModalOpen: true }, () => {
            this.usp_Transaction_WorkOrderRecvSelectForWorkPlanning();
            this.getNoCount();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.usp_Transaction_WorkPlanningSelectbyId(event.data.idWorkPlanning);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForRegister = () => {
        const newValidState = isValidForm(
            this.state.registerObject,
            this.state.validationRulesForPurchase,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFieldsForItem = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRulesForItem,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChangeForPurchase = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.workObject;
        details[name] = value;
        this.setState({ workObject: details });
    }
    handleChangeForItem = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details });
    }

    handleChangeForDropdown = (event, name, field) => {
        let details = this.state.workObject;
        let details1 = this.state.itemObject
        let value = event.value;
        if (field === 'workObject') {
            details[name] = value;
            this.setState({ workObject: details }, () => {
                if (name === 'idWorkOrder') {
                    this.usp_Transaction_MaterialPlanningSelectbyIDWorkOrder();
                }
            });
        } else {
            details1[name] = value;
            this.setState({ itemObject: details1 }, () => {
                if (name === 'idType') {
                    var itemName = this.state.itemObject.TypeList.find(x => x.value === this.state.itemObject.idType)?.label;
                    this.getMaster_ItemSelectbyItemType(itemName);
                }
            });
        }
    }

    resetDetailsFields = () => {
        let workObject = this.state.workObject;
        workObject.idMaterialPlanning = 0;
        workObject.idWorkPlanning = 0;
        workObject.updateStatus = 0;
        workObject.planningNo = '';
        workObject.planningDate = new Date().toISOString();
        workObject.idCustomer = 0;
        workObject.idEmployee = 0;
        //workObject.EmployeeList = [];
        workObject.idPriority = 2;
        workObject.idWorkOrder = 0;
        //workObject.workOrderList = [];
        //this.setState({ workObject: workObject });
        workObject.deleteItemsList = [];

        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState, workObject: workObject, itemRowData: []
        });
    }

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idWorkPlanning);
    };

    handleCellClickItemList = (event) => {
        //this.getMasterChequeBookSelectbyId(event.data.idChequeBookMaster);
        //let validState = this.state.validState;
        //validState.isValid = true;
        //validState.error = {};
        let itemData = this.state.itemRowData[event.data.keyId - 1];
        let data = this.state.itemObject;
        data.keyId = itemData.keyId;
        data.drawingNo = itemData.drawingNo;
        data.itemType = itemData.itemType;
        data.idType = data.TypeList?.find(x => x.label === itemData.itemType)?.value;
        data.idItem = itemData.idItem;
        data.itemName = itemData.ItemList?.find(x => x.value === itemData.idItem)?.itemName || "";
        data.quantity = Number(itemData.quantity);
        data.remarks = itemData.remarks || "";
        data.idMaterialPlanning = itemData.idMaterialPlanning || 0;
        data.idWorkPlanningItems = itemData.idWorkPlanningItems || 0;
        // data.keyId = itemData.keyId;
        // data.drawingNo = itemData.drawingNo;
        // data.itemType = itemData.itemType;
        // data.idType = data.TypeList?.find(x => x.label === itemData.itemType)?.value;
        // data.idItem = itemData.idItem;
        // //data.ItemList = [];
        // data.quantity = itemData.quantity;
        // data.remarks = itemData.remarks;
        // data.idIndentRegisterItems = itemData.idIndentRegisterItems;
        // data.idIndentRegister = itemData.idIndentRegister;
        // data.idPurchaseInquiryItems = itemData.idPurchaseInquiryItems;
        // data.utStatus = itemData.utStatus;
        // data.idMaterialPlanning = itemData.idMaterialPlanning;
        // data.idMaterialPlanningDetails = itemData.idMaterialPlanningDetails;
        this.setState({ itemObject: data }, () => {
            this.usp_Transaction_MaterialPlanningSelectbyIDWorkOrder();
            this.getMaster_ItemSelectbyItemType(this.state.itemObject.itemType);
        });
    };

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName, globalUserID: prop.globalUserID }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Transaction_WorkOrderRecvSelectForWorkPlanning();
                this.usp_GetAllUsers();
            });
        }
    }

    usp_GetAllUsers = () => {
        this.accountTransactionServices.usp_GetAllUsers().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({
                        usp_Users: data,
                    });
                }
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Work Planning",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.05,
                            //pinned: ["sR.No", "jobWorkNo", "jobWorkInwardDate", "jobWorkFrom", "invoiceNo"].includes(key) ? "left" : undefined,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idWorkPlanning"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Work Planning",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id);
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.08,
            "planningNo": window.innerWidth * 0.08,
            "date": window.innerWidth * 0.06,
            "customer": window.innerWidth * 0.25,
            "woRecvNo": window.innerWidth * 0.06,
            "closeStatus": window.innerWidth * 0.06,
            "productionStatus": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            // "sR.No": window.innerWidth * 0.05,
            // "jobWorkNo": window.innerWidth * 0.09,
            // "jobWorkInwardDate": window.innerWidth * 0.08,
            // "jobWorkFrom": window.innerWidth * 0.08,
            // "invoiceNo": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id) => {
        let request = {
            id: id,
            formname: "Work Planning",
            allowToRateVisible: 1,
            idPlant: this.state.idPlant ? this.state.idPlant : 0,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    getColumnWidth2 = (key) => {
        const colwidth = {
            // "drawingNo": window.innerWidth * 0.11,
            // "itemCategory": window.innerWidth * 0.16,
            // "itemName": window.innerWidth * 0.2,
            // "hsnCode": window.innerWidth * 0.06,
            // "quantity": window.innerWidth * 0.06,
            // "rate": window.innerWidth * 0.06,
            // "taxableAmt": window.innerWidth * 0.06,
            // "sgst": window.innerWidth * 0.04,
            // "sgstAmt": window.innerWidth * 0.06,
            // "cgst": window.innerWidth * 0.04,
            // "cgstAmt": window.innerWidth * 0.06,
            // "igst": window.innerWidth * 0.04,
            // "igstAmt": window.innerWidth * 0.06,
            // "netTotal": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    usp_Transaction_WorkOrderRecvSelectForWorkPlanning = () => {
        let request = [
            this.state.idCompany,
            this.state.workObject.idWorkPlanning,
            this.state.workObject.updateStatus
        ];
        this.transactionStockServices.usp_Transaction_WorkOrderRecvSelectForWorkPlanning(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent[0];
                dynamicData = dynamicData.map((x) => ({
                    value: x.idwoOrderRecv,
                    label: x.woRecvNo + ' - ' + x.partyACName,
                    //partyAddress: x.p_Address
                }));
                let obj = this.state.workObject;
                obj.workOrderList = dynamicData;
                // obj.idWorkOrder = obj.idWorkOrder;
                this.setState({ workObject: obj }, () => {
                    this.getMaster_ItemSelectbyItemType('RAW MATERIAL');
                }, () => {
                    if (this.gridApi) {
                        this.gridApi.hideOverlay();
                    }
                });
                this.getMaster_ItemSelectbyItemType('RAW MATERIAL');
            }
        });
    }

    getMaster_ItemSelectbyItemType = (label) => {
        let request = [label, this.state.idCompany];
        this.masterEntryServices.getMaster_ItemSelectbyItemType(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = this.state.itemObject;
                data = data.map((x) => ({
                    value: x.idItem,
                    label: x.itemCategory + ' - ' + x.itemName + ' - ' + x.drawingNo + ' - ' + x.searchText,
                    itemName: x.itemName
                }));
                itemObject.ItemList = data;
                // itemObject.idItem = itemObject.idItem;
                //}
                this.setState({
                    itemObject: itemObject,
                });
            }
        });
    }

    getNoCount = () => {
        let details = this.state.workObject;
        let maxIdPaymentMake = this.state.rowData.length > 0
            ? this.state.rowData.length
            : 0;
        let inwardNo = String(maxIdPaymentMake + 1).padStart(3, '0');
        details.planningNo = inwardNo;
        details.planningDate = moment(new Date()).format('YYYY-MM-DD');
        // details.planningNo = details.prefix + inwardNo;
        this.setState({ workObject: details })
    }

    // usp_Transaction_WorkOrderRecvSelectForPurchaseInquiry = () => {
    //     let request = [
    //         this.state.idCompany,
    //         this.state.purchaseObject.idPurchaseInquiry,
    //         this.state.purchaseObject.updateStatus
    //     ];
    //     this.transactionStockServices.usp_Transaction_WorkOrderRecvSelectForPurchaseInquiry(request).then((response) => {
    //         if (response.statusCode == 200 && response.responseItem !== null) {
    //             let dynamicData = response.responseItem.responseContent[0];
    //             if (dynamicData.length > 0) {
    //                 dynamicData = dynamicData.map((x) => ({
    //                     value: x.idwoOrderRecv,
    //                     label: x.woRecvNo + ' - ' + x.partyACName,
    //                     //partyAddress: x.p_Address
    //                 }));
    //                 let obj = this.state.purchaseObject;
    //                 obj.workOrderList = dynamicData;
    //                 obj.idWorkOrder = obj.idWorkOrder;
    //                 this.setState({ materialObject: obj }, () => {
    //                     this.getMaster_ItemSelectbyItemType('RAW MATERIAL', "itemTypeId2");
    //                 }, () => {
    //                     if (this.gridApi) {
    //                         this.gridApi.hideOverlay();
    //                     }
    //                 });
    //             } else {
    //                 this.getMaster_ItemSelectbyItemType('RAW MATERIAL');
    //             }
    //         }
    //     });
    // }

    usp_Transaction_MaterialPlanningSelectbyIDWorkOrder = () => {
        if (this.state.workObject.idWorkOrder > 0) {
            let request = [this.state.workObject.idWorkOrder];
            this.transactionStockServices.usp_Transaction_MaterialPlanningSelectbyIDWorkOrder(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    //let itemListRowData = this.state.itemObject;
                    let obj = this.state.itemObject;
                    obj.planningList = [];
                    if (dynamicData.length > 0) {
                        dynamicData = dynamicData.map((x) => ({
                            value: x.idMaterialPlanning,
                            label: x.itemName + ' - ' + x.drawingNo,
                            name: x.itemName
                        }));
                        obj.planningList = dynamicData;
                        // obj.idPlanning = obj.idPlanning;
                    }
                    this.setState({ itemObject: obj }, () => {
                        //this.getMaster_ItemSelectbyItemType('RAW MATERIAL', "itemTypeId2");
                    });
                    // itemListRowData.planningList =
                    //     this.setState({ itemRowData: itemListRowData });
                }
            });
        }
    }

    generateForWorkPlanning = () => {
        if (this.state.workObject.idWorkOrder > 0) {
            let request = [this.state.workObject.idWorkOrder];

            this.transactionStockServices
                .usp_Transaction_MaterialPlanningSelectbyIDWorkOrder_ForWorkPlanning(request)
                .then((response) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        let data = response.responseItem.responseContent;
                        let itemListRowData = [];

                        data.map((x) => {
                            let object = {};
                            object.drawingNo = x.drawingNo;
                            object.itemType = x.itemType;
                            object.idType = this.state.itemObject.TypeList.find(f => f.label === x.itemType)?.value;
                            object.idItem = x.idItem;
                            object.itemName = x.itemName;
                            object.quantity = x.piQuantity;
                            object.idMaterialPlanning = x.idMaterialPlanning ? x.idMaterialPlanning : 0;
                            object.idWorkPlanningItems = x.idWorkPlanningItems ? x.idWorkPlanningItems : 0;
                            // Optional extra fields (if needed)
                            object.remarks = x.remarks ?? "";
                            // object.idIndentRegisterItems = x.idIndentRegisterItems ?? 0;
                            // object.idIndentRegister = x.idIndentRegister ?? 0;
                            // object.idPurchaseInquiryItems = x.idPurchaseInquiryItems ?? 0;
                            // object.utStatus = x.utStatus ?? 0;
                            // object.idMaterialPlanningDetails = x.idMaterialPlanningDetails ?? 0;

                            itemListRowData.push(object);
                        });

                        // Add keyId (like auto-increment row index)
                        itemListRowData.map((x, key) => {
                            x.keyId = key + 1;
                        });

                        this.setState({ itemRowData: itemListRowData });
                    }
                });
        }
    }

    // getMaster_ItemSelectbyItemType = (label) => {
    //     let request = [label, this.state.idCompany];
    //     this.masterEntryServices.getMaster_ItemSelectbyItemType(request).then((response) => {
    //         if (response.statusCode === 200 && response.responseItem !== null) {
    //             let data = response.responseItem.responseContent;
    //             let itemObject = this.state.itemObject;
    //             data = data.map((x) => ({
    //                 value: x.idItem,
    //                 label: x.itemCategory + ' - ' + x.itemName + ' - ' + x.drawingNo + ' - ' + x.searchText,
    //                 itemName: x.itemName
    //             }));

    //             // if (name === 'itemTypeId2') {
    //             //     itemObject.ItemList = data;
    //             //     itemObject.itemId2 = "";
    //             // } else if (name === 'itemTypeId') {
    //             itemObject.ItemList = data;
    //             itemObject.idItem = "";
    //             //}
    //             this.setState({
    //                 itemObject: itemObject,
    //             });
    //         }
    //     });
    // }

    insert = (isFor) => {
        if (this.state.itemObject.idItem > 0 && Number(this.state.itemObject.quantity) > 0) {
            let itemObject = this.state.itemObject;
            let itemListRowData = [...this.state.itemRowData];
            let object = {
                drawingNo: itemObject.drawingNo,
                idType: itemObject.idType,
                itemType: itemObject.TypeList?.find(x => x.value === itemObject.idType)?.label || "",
                idItem: itemObject.idItem,
                itemName: itemObject.ItemList?.find(x => x.value === itemObject.idItem)?.itemName || "",
                quantity: Number(itemObject.quantity),
                remarks: itemObject.remarks || "",
                idMaterialPlanning: itemObject.idMaterialPlanning || 0,
                idWorkPlanningItems: itemObject.idWorkPlanningItems || 0,
            };
            if (isFor === "Update" && itemObject.keyId) {
                itemListRowData[itemObject.keyId - 1] = object;
            } else {
                itemListRowData.push(object);
            }
            itemListRowData = itemListRowData.map((x, key) => {
                return { ...x, keyId: key + 1 };
            });
            this.setState(
                { itemRowData: itemListRowData },
                () => this.resetItemDetails()
            );
        } else {
            this.SwalServices.Error("Please enter valid Item and Quantity.");
        }
    };

    resetItemDetails = () => {
        let itemObject = this.state.itemObject;
        itemObject.keyId = 0;
        itemObject.idWorkPlanningItems = 0;
        itemObject.idMaterialPlanning = 0;
        itemObject.drawingNo = '';
        //itemObject.idType = 1;
        itemObject.itemType = "";
        itemObject.idItem = 0;
        //itemObject.ItemList = [];
        itemObject.quantity = 0;
        itemObject.idPlanning = 0;
        itemObject.remarks = '';
        this.setState({
            itemObject: itemObject
        });
    }

    // resetWorkObjectDetails = () => {
    //     let itemObject = this.state.workObject;
    //     itemObject.idMaterialPlanning = 0;
    //     itemObject.idWorkPlanning = 0;
    //     itemObject.updateStatus = 0;
    //     itemObject.planningNo = '';
    //     itemObject.planningDate = new Date().toISOString();
    //     itemObject.idCustomer = 0;
    //     itemObject.idEmployee = 0;
    //     itemObject.EmployeeList = [];
    //     itemObject.idPriority = 2;
    //     itemObject.idWorkOrder = 0;
    //     itemObject.workOrderList = [];
    //     this.setState({ workObject: itemObject });
    // }

    submit = () => {
        if (this.isSubmitting) { return; }
        if (this.state.itemRowData.length === 0) {
            this.SwalServices.Error("Please add item details.");
            return;
        }

        let details = this.state.workObject;

        let requestData = {
            idMaterialPlanning: details.idMaterialPlanning,
            idWorkPlanning: details.idWorkPlanning,
            planningNo: details.planningNo,
            date: details.planningDate ? moment(details.planningDate).format("YYYY-MM-DD") : null,
            priority: details.priorityList.find(x => x.value === details.idPriority)?.label,
            authEmployee: details.idCustomer,
            idCustomer: details.idEmployee,
            idWOOrderRecv: details.idWorkOrder,
            idWOOrderRecvItems: 0,
            idCompany: this.state.idCompany,

            e_Date: new Date().toISOString(),
            e_IDUser: this.state.idUser,
            isUpdated: details.updateStatus === 1 ? 1 : 0,
            u_IDUser: details.updateStatus === 1 ? this.state.idUser : 0,
            updatedDate: details.updateStatus === 1 ? new Date().toISOString() : null,
            isDeleted: 0,
            deletedDate: null,
            d_IDUser: 0,

            //planningQty: details.planningQty || 0,
            //idFinancialYear: this.state.idFinancialYear || null,

            itemList: [],
            deleteItemsList: details.deleteItemsList,
        };

        this.state.itemRowData.forEach((x) => {
            let obj = {
                drawingNo: x.drawingNo,
                itemType: x.itemType || "",
                idItem: x.idItem || x.idItem,
                quantity: Number(x.quantity) || 0,
                itemRemarks: x.itemRemarks || "",
                idMaterialPlanning: x.idMaterialPlanning || 0,
                idWorkPlanningItems: x.idWorkPlanningItems || 0
            }
            requestData.itemList.push(obj);
        });

        this.isSubmitting = true;
        this.setState({ isSaving: true });
        this.transactionStockServices
            .usp_Transaction_WorkPlanningInsertUpdate(requestData)
            .then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    if (dynamicData?.errorType === "Exists") {
                        this.SwalServices.Warning(dynamicData.errorMessage);
                    } else {
                        if (details.updateStatus === 1) {
                            this.SwalServices.Success("Updated successfully.");
                        } else {
                            this.SwalServices.Success("Saved successfully.");
                        }
                        this.resetDetailsFields();
                        this.resetItemDetails();
                        //this.resetWorkObjectDetails();
                        //this.resetWorkPlanningObject();
                        this.setState({ isModalOpen: false }, () => {
                            this.procSelectAllRecordsSP();
                            this.usp_Transaction_WorkOrderRecvSelectForWorkPlanning();
                        });
                    }
                } else {
                    this.setState({ isModalOpen: false }, () => {
                        this.SwalServices.Error(response.message);
                        this.procSelectAllRecordsSP();
                        this.usp_Transaction_WorkOrderRecvSelectForWorkPlanning();
                    });
                }
            })
            .catch((err) => {
                this.SwalServices.Error("Something went wrong: " + err.message);
            })
            .finally(() => { this.isSubmitting = false; this.setState({ isSaving: false }); });
    };


    usp_Transaction_WorkPlanningSelectbyId = (id) => {
        if (id > 0) {
            this.transactionStockServices.usp_Transaction_WorkPlanningSelectbyId(id).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0][0];
                    let res2 = response.responseItem.responseContent[1];

                    let workObject = this.state.workObject;

                    workObject.idMaterialPlanning = res.idMaterialPlanning;
                    workObject.idWorkPlanning = res.idWorkPlanning;
                    workObject.updateStatus = 1;
                    workObject.planningNo = res.planningNo;
                    workObject.planningDate = moment(res.planningDate).format('YYYY-MM-DD') ?? '';
                    workObject.idCustomer = res.idCustomer;
                    workObject.idEmployee = res.idEmployee;
                    //workObject.EmployeeList = [];
                    workObject.idPriority = workObject.priorityList.find(x => x.label === res.priority)?.value;
                    //workObject.priorityList = [];
                    workObject.idWorkOrder = res.idwoOrderRecv;
                    //workObject.workOrderList = [];

                    // itemObject.idPurchaseInquiry = res.idPurchaseInquiry;
                    // itemObject.piNo = res.inquiryNo;
                    // itemObject.piDate = res.inquiryDate ? moment(res.inquiryDate).format('YYYY-MM-DD') : '';
                    // itemObject.idEmployee = res.authEmployee;
                    // itemObject.idWorkOrder = res.idwoOrderRecv ?? 0;
                    // itemObject.updateStatus = 1;
                    // itemObject.e_Date = res.e_Date ?? "";

                    let itemListRowData = [];
                    res2?.map((x) => {
                        let object = {
                            drawingNo: x.drawingNo,
                            itemType: x.itemType || "",
                            idItem: x.idItem || x.idItem,
                            itemName: x.itemName || x.itemName,
                            quantity: Number(x.quantity) || 0,
                            itemRemarks: x.itemRemarks || "",
                            idMaterialPlanning: x.idMaterialPlanning || 0,
                            idWorkPlanningItems: x.idWorkPlanningItems || 0
                            // drawingNo: x.itemDrawingNo,
                            // itemType: x.itemItemType,
                            // idItem: x.idItem,
                            // itemName: x.itemName,
                            // quantity: x.quantity,
                            // idIndentRegisterItems: x.idIndentRegisterItems ? x.idIndentRegisterItems : 0,
                            // idIndentRegister: x.idIndentRegister ? x.idIndentRegister : 0,
                            // remarks: x.itemRemarks ? x.itemRemarks : "",
                            // idPurchaseInquiryItems: x.idPurchaseInquiryItems ? x.idPurchaseInquiryItems : 0,
                            // idMaterialPlanningDetails: x.idMaterialPlanningDetails ? x.idMaterialPlanningDetails : 0,
                            // utStatus: 1,
                            // idMaterialPlanning: x.idMaterialPlanning ? x.idMaterialPlanning : 0,
                        };
                        itemListRowData.push(object);
                    });
                    itemListRowData?.map((x, key) => {
                        x.keyId = key + 1;
                    });

                    this.setState({
                        workObject: workObject,
                        itemRowData: itemListRowData,
                        isModalOpen: true,
                        globalUserID: res.modifiedBy
                    }, () => {
                        this.usp_Transaction_WorkOrderRecvSelectForWorkPlanning();
                        this.usp_Transaction_MaterialPlanningSelectbyIDWorkOrder();
                    });
                    // let responseWorkOrderList = this.transactionStockServices
                    //     .usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning(requestWorkOrderList);

                    // if (responseWorkOrderList.statusCode == 200 && responseWorkOrderList.responseItem !== null) {
                    //     let resDropdown = responseWorkOrderList.responseItem.responseContent;
                    //     if (resDropdown.length > 0) {
                    //         resDropdown = resDropdown.map((x) => ({
                    //             value: x.idwoOrderRecv,
                    //             label: x.woRecvNo + " - " + x.priority,
                    //         }));
                    //         obj.workOrderList = resDropdown;
                    //     }
                    // }
                }
            });
        }
    };

    deleteItem = (keyId) => {
        let data = this.state.workObject;
        let idWorkPlanningItems = this.state.itemRowData?.find(item => item.keyId == keyId)?.idWorkPlanningItems;
        let filterData = this.state.itemRowData?.filter(item => item.keyId !== keyId);
        if (filterData.length > 0) {
            filterData.map((x, key) => {
                x.keyId = key + 1;
            });
        }
        //data.itemList = filterData;
        if (idWorkPlanningItems > 0) {
            data.deleteItemsList.push(idWorkPlanningItems);
        }
        this.setState({ purchaseObject: { ...data }, itemRowData: filterData }, () => {
            this.resetItemDetails();
        });
    }

    render() {
        return (
            <div className='purchase-inquiry'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <WorkPlanningPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            workObject={this.state.workObject}
                            itemObject={this.state.itemObject}
                            handleChangeForPurchase={this.handleChangeForPurchase.bind(this)}
                            handleChangeForItem={this.handleChangeForItem.bind(this)}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            itemColDefs={this.state.itemColDefs}
                            generate={this.generateForWorkPlanning.bind(this)}
                            insert={this.insert.bind(this)}
                            handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                            deleteItem={this.deleteItem.bind(this)}
                            usp_Users={this.state.usp_Users}
                            globalUserID={this.state.globalUserID}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Work Planning</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    onCellClicked={this.handleCellClick}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
